var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoodValues(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4dc7f7",
    floodOpacity: 0.659
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 9.61,
    y: 9.61,
    width: 80.781,
    height: 80.78,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0acb63"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 12.606,
    y: 12.606,
    width: 74.787,
    height: 74.787,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0acb63"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 16.102,
    y: 16.102,
    width: 67.796,
    height: 67.795,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0acb63"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 21.601,
    y: 21.475,
    width: 56.798,
    height: 56.798,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "o"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0acb63"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "o"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1356.5 -337.662)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1371.5 352.662)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 15)",
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1,
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 34.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.39,
    cy: 25.39,
    r: 25.39,
    transform: "translate(24.61 24.61)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.394,
    cy: 22.394,
    r: 22.394,
    transform: "translate(27.61 27.61)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.898,
    cy: 18.898,
    r: 18.898,
    transform: "translate(31.1 31.1)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.399,
    cy: 13.399,
    r: 13.399,
    transform: "translate(36.6 36.48)",
    fill: "url(#a)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodValues);
export default __webpack_public_path__ + "static/media/goodValues.023684d4638e0b7257a95f1593040bb0.svg";
export { ForwardRef as ReactComponent };